import { render, staticRenderFns } from "./BDashboardChangeWidget.vue?vue&type=template&id=15849641&scoped=true"
import script from "./BDashboardChangeWidget.vue?vue&type=script&lang=js"
export * from "./BDashboardChangeWidget.vue?vue&type=script&lang=js"
import style0 from "./BDashboardChangeWidget.vue?vue&type=style&index=0&id=15849641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15849641",
  null
  
)

export default component.exports